<template>
  <div
    class="max-w-[300px] bg-white border border-gray-200 rounded-lg shadow-sm grid grid-rows-[auto,1fr,auto]">
    <img class="rounded-t-lg" :src="imageSrc" :alt="altText" />
    <!-- Image superposée si adopté -->
    <img v-if="chatMaleAdopte" src="/src/assets/images/adopte_male.png" alt="Adopté"
      class="absolute  object-contain opacity-80" />
    <img v-if="chatFemelleAdoptee" src="/src/assets/images/adopte_femelle.png" alt="Adoptée"
      class="absolute object-contain opacity-80" />
    <!-- Image superposée si réservé -->
    <div class="px-3 py-5 border-t-2 border-gray-200">
      <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900  break-words">{{ title }}
        <span v-if="reserved" class="text-primaire"> (Réservée)</span>
      </h5>
      <ul class="mb-3 font-normal text-gray-700">
        <li v-for="(detail, index) in details" :key="index">{{ detail }}</li>
        <li v-if="infoAdditionnel" class="text-navigation font-bold italic">{{ infoAdditionnel }}</li>
      </ul>
    </div>
    <slot></slot> <!-- Permet d'insérer un bouton personnalisé -->
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    imageSrc: {
      type: String,
      required: true,
    },
    altText: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    details: {
      type: Array,
      required: true,
    },
    reserved: {
      type: Boolean,
      default: false, //Par défaut, l'animal n'est pas réservé.
    },
    chatFemelleAdoptee: {
      type: Boolean,
      default: false, // Par défaut, l'animal n'est pas adopté.
    },
    chatMaleAdopte: {
      type: Boolean,
      default: false, // Par défaut, l'animal n'est pas adopté.
    },
    infoAdditionnel: {
      type: String,
      default: '', // Par défaut, aucune information supplémentaire n'est fournie.
    }
  },
};
</script>

<style scoped>
img {
  aspect-ratio: 4 / 3;
  width: 100%;
  height: auto;
}
</style>